import React from "react";
import {
  IonAvatar,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonBadge,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
} from "@ionic/react";
import "../theme/AppStyles.css";

interface DoubleBookedJob {
  jobId: string;
  jobTitle: string;
  numJobSlots: number;
  numWerkersAssigned: number;
  overbookedBy: number;
  jobDate?: string;
  werkersList?: string[];
}

interface SchedulerDoubleBooking {
  schedulerUID: string;
  schedulerName: string;
  schedulerPICURL: string;
  doubleBookedJobs: DoubleBookedJob[];
  totalDoubleBookings: number;
}

interface DoubleBookingsProps {
  doubleBookingsList: SchedulerDoubleBooking[];
}

export const DoubleBookings: React.FC<DoubleBookingsProps> = ({ doubleBookingsList }) => {
  // console.log("Double Bookings List:", doubleBookingsList);

  // Sort schedulers by number of double bookings (descending)
  const sortedList = [...doubleBookingsList].sort(
    (a, b) => b.totalDoubleBookings - a.totalDoubleBookings
  );

  if (!doubleBookingsList || doubleBookingsList.length === 0) {
    return (
      <IonCard>
        <IonCardContent>
          <p style={{ textAlign: "center", padding: "20px" }}>
            No double bookings found
          </p>
        </IonCardContent>
      </IonCard>
    );
  }

  return (
    <React.Fragment>
      <IonListHeader>
        <h2>Double Bookings Summary</h2>
      </IonListHeader>
      <IonList>
        {sortedList.map((scheduler) => {
          // Count only jobs that are actually overbooked
          const overbookedJobsCount = scheduler.doubleBookedJobs.filter(job => job.overbookedBy > 0).length;
          const totalJobs = scheduler.doubleBookedJobs.length;
          
          return (
          <IonCard key={scheduler.schedulerUID}>
            <IonCardHeader>
              <IonItem lines="none">
                <IonAvatar
                  className="avatario"
                  slot="start"
                >
                  <img src={scheduler.schedulerPICURL} alt="" />
                </IonAvatar>
                <IonLabel>
                  <IonCardTitle>
                    {scheduler.schedulerName}
                  </IonCardTitle>
                  {/* <p style={{ fontSize: "0.9em", marginTop: "4px" }}>
                    <strong>{overbookedJobsCount}</strong> overbooked of <strong>{totalJobs}</strong> jobs
                  </p> */}
                </IonLabel>
                <div slot="end" style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px" }}>
                  <IonBadge
                    color="danger"
                  >
                    {overbookedJobsCount} Overbooked
                  </IonBadge>
                  <IonBadge
                    color="medium"
                  >
                    {totalJobs} Total
                  </IonBadge>
                </div>
              </IonItem>
            </IonCardHeader>
            <IonCardContent>
              <IonList>
                {scheduler.doubleBookedJobs.map((job, index) => (
                  <IonItem
                    key={`${job.jobId}-${index}`}
                    lines="full"
                  >
                    <IonLabel className="ion-text-wrap">
                      <h2 style={{ fontWeight: "bold", marginBottom: "8px" }}>
                        {job.jobTitle || `Job ${job.jobId.substring(0, 8)}`}
                      </h2>
                      {job.jobDate && (
                        <p style={{ marginBottom: "6px" }}>
                          <strong>📅 Date:</strong> {job.jobDate}
                        </p>
                      )}
                      <p style={{ fontSize: "0.85em", marginBottom: "8px", wordBreak: "break-all" }}>
                        <strong>Job ID:</strong> {job.jobId}
                      </p>
                      <div style={{ marginBottom: "8px" }}>
                        <IonBadge color="medium" style={{ marginRight: "4px" }}>
                          Slots: {job.numJobSlots}
                        </IonBadge>
                        <IonBadge color="warning" style={{ marginRight: "4px" }}>
                          Assigned: {job.numWerkersAssigned}
                        </IonBadge>
                        <IonBadge color="danger">
                          +{job.overbookedBy} Over
                        </IonBadge>
                      </div>
                      {job.werkersList && job.werkersList.length > 0 && (
                        <div style={{ 
                          marginTop: "8px", 
                          padding: "8px", 
                          backgroundColor: "var(--ion-color-light)",
                          borderRadius: "4px"
                        }}>
                          <strong>👷 Assigned Werkers ({job.werkersList.length}):</strong>
                          <div style={{ marginTop: "4px", fontSize: "0.9em" }}>
                            {job.werkersList.map((werker, idx) => (
                              <div key={idx}>• {werker}</div>
                            ))}
                          </div>
                        </div>
                      )}
                    </IonLabel>
                  </IonItem>
                ))}
              </IonList>
            </IonCardContent>
          </IonCard>
        );
        })}
      </IonList>
    </React.Fragment>
  );
};
